import { render } from "./EmailVerificationNotice.vue?vue&type=template&id=126f8f9b&scoped=true"
import script from "./EmailVerificationNotice.vue?vue&type=script&lang=js"
export * from "./EmailVerificationNotice.vue?vue&type=script&lang=js"

import "./EmailVerificationNotice.vue?vue&type=style&index=0&id=126f8f9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126f8f9b"]])

export default __exports__